// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2DoPW","content":"LoadingAlert_content__FRMXS"};